import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';
import { AriaDirective } from '../../../shared-components/directives/aria.directive';
import { AttendanceDetails } from '../../../shared-components/student/attendance-details.model';
import { LoginService } from '../../../shared-modules/login/login.service';

@Component({
  selector: 'by-date-details',
  templateUrl: './by-date-details.component.html'
})
export class ByDateDetailsComponent implements OnInit, OnDestroy {

  // ----------Angular Material------------------------------------
  angularMatData = new TylerMatTableDataSource();
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  columnsToDisplay = [];
  @Input() attendanceDetails: AttendanceDetails[];
  @Input() calendarUseAttendanceTypes: boolean;
  V10: boolean;
  constructor(
    private loginService: LoginService
  ) {
    this.V10 = this.loginService.LoginSettings.V10;
  }

  ngOnInit() {
    this.angularMatData.data = this.attendanceDetails;

    //  Custom sorting for case here Academic Year starts with letters
    //  Extracts last two characters and returns the resulting substring if it is a number
    this.angularMatData.sortingDataAccessor = (item: any, property: string) => {
      if (property == 'Course-Section') {
        return item['SubjectCode'] + item['Section'];
      }
      //  Default sorting
      else {
        return this.angularMatData.defaultSortingAccessor(item, property);
      }
    };

    this.angularMatData.sort = this.sort;

    if (this.loginService.LoginSettings.S360HideAttendanceComments == false) {
      if (this.V10 == false) {
        if (this.calendarUseAttendanceTypes) {
          this.columnsToDisplay = ['Meets', 'PeriodCode', 'Term', 'Course-Section', 'Course', 'AttendanceCode', 'AttendanceType', 'AttendanceCodeDescription' , 'Comment'];
        }
        else {
          this.columnsToDisplay = ['Meets', 'PeriodCode', 'Term', 'Course-Section', 'Course', 'AttendanceCode', 'AttendanceCodeDescription' , 'Comment'];
        }
      }
      else {
        this.columnsToDisplay = ['Meets', 'PeriodCode', 'Dropped', 'Term', 'Course-Section', 'Course', 'AttendanceCode', 'Comment'];
      }
    }
    else {
      if (this.V10 == false) {
        if (this.calendarUseAttendanceTypes) {
          this.columnsToDisplay = ['Meets', 'PeriodCode', 'Term', 'Course-Section', 'Course', 'AttendanceCode', 'AttendanceType' , 'AttendanceCodeDescription'];
        }
        else {
          this.columnsToDisplay = ['Meets', 'PeriodCode', 'Term', 'Course-Section', 'Course', 'AttendanceCode', 'AttendanceCodeDescription'];
        }
      }
      else {
        this.columnsToDisplay = ['Meets', 'PeriodCode', 'Dropped', 'Term', 'Course-Section', 'Course', 'AttendanceCode'];
      }
    }
  }

  ngOnDestroy() {
    // POST: ends all subscriptions
  }

  getAriaDetailRowByDate(row: AttendanceDetails): string {
    const colList: string[] = ['Meets',
      'Dropped',
      'Term',
      'Course-Section',
      'Course Name',
      'Code',
      'Comment'];

    const dataList: string[] = [row.Meets,
    row.Dropped,
    row.Term,
    row.SubjectCode.concat('-', row.Section),
    row.AttendanceCode,
    row.Comment];

    return AriaDirective.concatAriaStrings(colList, dataList);
  }

}
